import React from 'react';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import { InlineTextButton } from '../Button/Button';
import IconArrowHead from '../IconArrowHead/IconArrowHead';

import css from './GoBack.module.css';

const GoBack = ({ className }) => {
  const history = useHistory();

  const classes = classNames(css.root, className);

  return (
    <InlineTextButton onClick={() => history.goBack()} className={classes}>
      ← <FormattedMessage id="Global.goBack" />
    </InlineTextButton>
  );
};

export default GoBack;
